/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from './map-command.class';
import { InjectionToken } from '@angular/core';
import { COPY_LAT_LON_COMMAND } from './copy-lat-lon/copy-lat-lon.token';
import { SELECT_COMMAND } from './select/select.token';
import { DESELECT_COMMAND } from './deselect/deselect.token';
import { PAN_COMMAND } from './pan/pan.token';
import { RELOAD_COMMAND } from './reload/reload.token';
import { CREATE_BUFFER_COMMAND } from './buffer/create-buffer/create-buffer.token';
import { SELECT_WITHIN_BUFFER_COMMAND } from './buffer/select-within-buffer/select-within-buffer.token';
import { CLEAR_BUFFER_COMMAND } from './buffer/clear-buffer/clear-buffer.token';
import { ZOOM_IN_COMMAND } from './zoom-in/zoom-in.token';
import { ZOOM_OUT_COMMAND } from './zoom-out/zoom-out.token';
import { ZOOM_EXTENTS_COMMAND } from './zoom-extents/zoom-extents.token';
import { ZOOM_LAT_LON_COMMAND } from './zoom-lat-lon/zoom-lat-lon.token';
import { SEARCH_COMMAND } from './search/search.token';
import { DATA_REPORT_COMMAND } from './data-report/data-report.token';
import { DIGITIZE_POINT_COMMAND } from './digitize-point/digitize-point.token';
import { LAUNCH_URL_COMMAND } from './launch-url/launch-url.token';
import { POLYGON_SELECT_COMMAND } from './polygon-select/polygon-select.token';
import { LAUNCH_GOOGLE_MAPS_COMMAND } from './launch-google-maps/launch-google-maps.token';
import { MEASURE_COMMAND } from './measure/measure.token';
import { PRINT_COMMAND } from './print/print.token';
import { MARKUP_COMMAND } from './markup/markup.token';
import { LOGOUT_COMMAND } from './logout/logout.token';
import { LIVE_SEARCH_COMMAND } from './live-search/live-search.token';
import { ATTACH_COMMAND } from './attach/attach.token';

export interface WidgetLocatorEntry {
    name: string;
    token: InjectionToken<MapCommand>;
}

export const MAP_COMMAND_LIST: WidgetLocatorEntry[] = [
    { name: 'Attach', token: ATTACH_COMMAND },
    { name: 'CopyLatLon', token: COPY_LAT_LON_COMMAND },
    { name: 'Select', token: SELECT_COMMAND },
    { name: 'Deselect', token: DESELECT_COMMAND },
    { name: 'Pan', token: PAN_COMMAND },
    { name: 'Reload', token: RELOAD_COMMAND },
    { name: 'CreateBuffer', token: CREATE_BUFFER_COMMAND },
    { name: 'SelectWithinBuffer', token: SELECT_WITHIN_BUFFER_COMMAND },
    { name: 'ClearBuffer', token: CLEAR_BUFFER_COMMAND },
    { name: 'ZoomIn', token: ZOOM_IN_COMMAND },
    { name: 'ZoomOut', token: ZOOM_OUT_COMMAND },
    { name: 'ZoomExtents', token: ZOOM_EXTENTS_COMMAND },
    { name: 'ZoomLatLon', token: ZOOM_LAT_LON_COMMAND },
    { name: 'Search', token: SEARCH_COMMAND },
    { name: 'DataReport', token: DATA_REPORT_COMMAND },
    { name: 'DigitizePoint', token: DIGITIZE_POINT_COMMAND },
    { name: 'LaunchUrl', token: LAUNCH_URL_COMMAND },
    { name: 'PolygonSelect', token: POLYGON_SELECT_COMMAND },
    { name: 'LaunchGoogleMaps', token: LAUNCH_GOOGLE_MAPS_COMMAND },
    { name: 'Measure', token: MEASURE_COMMAND },
    { name: 'Print', token: PRINT_COMMAND },
    { name: 'Markup', token: MARKUP_COMMAND },
    { name: 'Logout', token: LOGOUT_COMMAND },
    { name: 'LiveSearch', token: LIVE_SEARCH_COMMAND },
];
